import React, {forwardRef, useEffect, useRef} from "react";
import Dragger from "antd/es/upload/Dragger";
import {getImageExt, hasLicense, imgPathPerfix, isImage, isInDraw} from "../../utils";
import {ipcInvoke, ipcSend} from "../../common/ipc";
import {t} from "i18next";
import {Button, message, Upload} from "antd";
import DialogImageUrl from "@/views/Draw/DialogImageUrl";
import {recvMessage, unSubscribe} from "@/common/event";
import {EVENT_MINDMAP_LINK_INFO, EVENT_PASTE_FILE_MESSAGE, FROM_LIBRARY, MAX_SIZE} from "@/Const";
import {readImageBase64FromClipboard} from "@/Utility0";
import global from "@/global";
import {file} from "../../../@excalidraw/packages/excalidraw/components/icons";

const ChooseImage =forwardRef((props:{onOkClicked:any,onCancelClicked:any,from:any}, ref)=>{

    const dialogImageUrlRef = useRef(null);
    const divContainerRef = useRef(null);

    const uploadProps:{ beforeUpload: (file:any,fileList:any) => string } = {
        beforeUpload:(file,fileList)=>{
            if (props.from == FROM_LIBRARY){
                //多个图片
                if (file == fileList[fileList.length - 1]){
                    props.onOkClicked({action:'file',file:fileList});
                }
            }else{
                if (file.size > MAX_SIZE){
                    message.error(t("The maximum file"));
                    return Upload.LIST_IGNORE;
                }
                // if (isImage(file.name)){
                //     excalidrawRef.getApp()?.insertImgElement(file);
                // }else{
                //     ipcInvoke('copy-file',{filePath:file.path}).then(res=>{
                //         //insert file type
                //         excalidrawRef.insertFileElement(res);
                //     });
                // }
                props.onOkClicked({action:'file',file});
            }
            return Upload.LIST_IGNORE
        }
    }

    useEffect(()=>{
        global.g_showDialogs['chooseImage'] = true;
        return ()=>{
            global.g_showDialogs['chooseImage'] = false;
        }
    },[])

    //接收paste消息
    useEffect(()=>{
        recvMessage(EVENT_PASTE_FILE_MESSAGE,async (msg,data)=>{
            const file = data.data.file;
            if (file){
                if (!file.path){
                    file.imageBase64 = await readImageBase64FromClipboard(divContainerRef.current);
                }
                props.onOkClicked({action:'file',file})
            }
        })

        document.body.addEventListener('paste',onPaste);

        return ()=>{
            unSubscribe(EVENT_PASTE_FILE_MESSAGE);
            document.body.removeEventListener('paste',onPaste);
        }
    })

    /**
     * 这里也要处理粘贴，很多地方，有的要，有的不要
     * @param event
     */
    async function onPaste(event){
        if (!isInDraw()){
            if (event.clipboardData.files && event.clipboardData.files.length > 0) {
                const files = event.clipboardData.files;
                const file = files[0];
                if (!file.path){
                    file.imageBase64 = await readImageBase64FromClipboard(divContainerRef.current);
                }
                props.onOkClicked({action:'file',file})
            }
        }
    }

    return(
        <div ref={divContainerRef} className='font-size-12' style={{
            width: '100%',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '266px',
            justifyContent: 'center',
            position: 'relative'
        }}>


            <Dragger {...uploadProps} multiple={true} accept={getImageExt()}
                     style={{
                         outline: 'none',
                         border: '0px',
                         background: 'transparent',
                         position: 'absolute',
                         width: '100%',
                         height: '100%',
                         left: '0',
                         top: '0'
                     }}>
                <div className={'flex-col default-font-color'} style={{marginTop: '76px'}}>
                    <span style={{
                        marginTop: '-16px',
                        lineHeight: '24px',
                        textAlign: 'center'
                    }}>{t("OrDragFile")}</span>
                    <div>
                    <span style={{
                        color: 'var(--text-color-afafaf)',
                        lineHeight: '22px',
                        textAlign: 'center'
                    }}>{t("PasteImageOrUrl")}</span>
                        <span className={'cursor-pointer'} style={{
                            textDecoration: 'underline',
                            color: 'var(--text-color-afafaf)',
                            lineHeight: '22px',
                            textAlign: 'center'
                        }} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            dialogImageUrlRef.current?.onShowDialog();
                        }}>url</span>
                    </div>
                </div>

            </Dragger>

            <div className={'button-solid-style flex-center'} style={{minWidth: '162px',position:'absolute',zIndex:'10',marginBottom:'45px'}} onClick={() => {
                props.onOkClicked({action: 'uploadImage'})
            }}>
                <span>{t("Upload image")}</span>
            </div>


            <DialogImageUrl ref={dialogImageUrlRef} onOkEvent={(szImageBase64: string) => {
                props.onOkClicked({action: 'base64', base64Image: szImageBase64})
            }}/>
        </div>
    )
})

export default ChooseImage;